var exports = {
  "x": "x7f9a0e16--941943--button",
};

module.exports = exports;
